import { Navigate } from 'react-router-dom';
import { useOrganisation } from '../contexts/OrganisationContext';

const ProtectedE2EUserRoute = ({ children }) => {
    const { activeRoleId } = useOrganisation();

    if (!activeRoleId?.toLowerCase().endsWith('-e2e-tester')) {
        return <Navigate to="/start" replace />;
    }

    return children;
};

export default ProtectedE2EUserRoute;